/**
 * Guest CRUD — backed by /api/guests.
 */
import { useCrudCollection } from './useCrudCollection';

export function useGuests() {
  const crud = useCrudCollection({ basePath: 'guests' });
  return {
    guests: crud.items,
    setGuests: crud.setItems,
    fetchGuests: crud.fetch,
    createGuest: crud.create,
    updateGuest: crud.update,
    deleteGuest: crud.remove,
  };
}
